import { isSandboxEnvironment, env } from '@config/env'
import { AUTH_CONTENT } from '../constants/authContent'

/**
 * Sandbox warning banner — Angular login parity.
 * Shown when hostname is not the production cornerstone host.
 */
export function SandboxBanner() {
  if (!isSandboxEnvironment()) return null

  const copy = AUTH_CONTENT.sandboxWarning
  const productionUrl = env.auth.productionAppUrl
  const helpEmail = env.auth.helpEmail

  return (
    <div className="bg-red-600 px-3 py-2 text-center text-xs leading-relaxed text-white sm:px-4 sm:text-sm">
      <p className="break-words">
        {copy.message}{' '}
        <a
          href={productionUrl}
          className="break-all font-semibold underline"
          target="_self"
        >
          {productionUrl}
        </a>
        . For more information get in touch with{' '}
        <a
          href={`mailto:${helpEmail}`}
          className="break-all font-semibold underline"
          target="_top"
        >
          {helpEmail}
        </a>
      </p>
    </div>
  )
}
